var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('Header',{attrs:{"msg":"Header"}}),_c('SettingsHeader',{attrs:{"msg":"SettingsHeader"}})],1),_c('main',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"editor"},[_c('p',[_vm._v("頁面版本："+_vm._s(_vm.version)+"-"+_vm._s(_vm.uiVersion))]),_c('p',[_vm._v("系統版本："+_vm._s(_vm.beVersion))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }